import { RavRecord, RecordSlots } from '#record/model';
import { DetailContext } from '#vessel/context';
import { useContext } from 'react';
import { avlType } from './constants';
import { AvlDeclaration } from './model';

export type AvlListEntry = {

    declaration: AvlDeclaration
    revision: RavRecord & Pick<RecordSlots , typeof avlType>
}

export const useAvlList = () => {

    const { vessel } = useContext(DetailContext)

    return (age: number) => {

        const avlMap = vessel.history.slice(age)
            .filter(r => r[avlType])
            .flatMap(revision =>  revision[avlType]!.declarations.map((declaration,i) => ({
                revision, 
                declaration
            
            } as AvlListEntry)))
            .reduce((acc, item) => {

                const key = `${item.declaration?.year ?? ''}${item.declaration.tenant ?? ''}`

                return acc.hasOwnProperty(key) ? acc : { ...acc, [key]: item }

            }, {} as Record<string, AvlListEntry>)

        return Object.values(avlMap).sort((a, b) => Number(b.declaration.year) - Number(a.declaration.year))
    }

}